import { Box, TextField } from "@mui/material";
import React from "react";

import { useCelleraTheme } from "../../../theme/useCelleraTheme";

interface IntakeFieldProps {
  label: string;
  value?: number | string;
  rows?: number;
  disabled?: boolean;
  multiline?: boolean;
  maxLength?: number;
}

const IntakeField: React.FC<IntakeFieldProps> = ({
  label,
  value,
  rows = 1,
  disabled = true,
  multiline = false,
  maxLength = 2000,
}) => {
  const { colors } = useCelleraTheme();

  const isMultiline = multiline || rows > 1;
  const currentLength = String(value || "").length;

  return (
    <Box sx={{ mb: 2 }}>
      <TextField
        {...(value ? { label } : {})}
        placeholder={label}
        value={value ?? ""}
        disabled={disabled}
        {...(!multiline && { rows })}
        multiline={isMultiline}
        slotProps={{
          htmlInput: {
            style: { textAlign: "left" },
          },
        }}
        sx={{
          width: "100%",
          position: "relative",
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            padding: "0px",
            "& fieldset": {
              borderColor: colors.border.light,
            },
            "&:hover fieldset": {
              borderColor: colors.primary.main,
            },
            "&.Mui-focused fieldset": {
              borderColor: colors.primary.main,
            },
          },
          "& .MuiInputBase-input": {
            padding: "12px 16px",
            fontSize: "16px",
            fontWeight: 500,
            color: colors.text.primary,
            "&.Mui-disabled": {
              WebkitTextFillColor: colors.text.secondary,
              opacity: 0.6,
            },
          },
          "& .MuiInputBase-inputMultiline": {
            textAlign: "justify !important",
          },
          // Character counter positioned inside the field
          ...(isMultiline && {
            "&::after": {
              content: `"${currentLength}/${maxLength}"`,
              position: "absolute",
              bottom: "8px",
              right: "8px",
              fontSize: "12px",
              color: colors.text.secondary,
              pointerEvents: "none",
            },
          }),
        }}
      />
    </Box>
  );
};

export default IntakeField;
